import { infiniteQueryOptions, queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getMaintenanceItemsByMaintenanceId,
  getMaintenanceItemsWithNotesByDeviceId,
} from "@/api/resources/maintenanceItems/api";
import i18n from "@/providers/i18n";

const NOTES_PAGE_SIZE = 5;

const entities = i18n.t("tasks");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const maintenanceItemsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "maintenanceItems"],
  lists: () => [...maintenanceItemsQueryKeys.all(), "list"],
  listById: (maintenance_id?: string) => [...maintenanceItemsQueryKeys.lists(), "listById", maintenance_id],
  listNotesInfiniteByDeviceId: (device_id?: string) => [
    ...maintenanceItemsQueryKeys.lists(),
    "listNotesInfiniteByDeviceId",
    device_id,
  ],
};

export const maintenanceItemsQueries = {
  listById: (maintenance_id?: string) =>
    queryOptions({
      queryKey: [...maintenanceItemsQueryKeys.listById(maintenance_id)],
      queryFn: maintenance_id ? () => getMaintenanceItemsByMaintenanceId(maintenance_id) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listNotesInfiniteByDeviceId: (device_id?: string) =>
    infiniteQueryOptions({
      queryKey: [...maintenanceItemsQueryKeys.listNotesInfiniteByDeviceId(device_id)],
      queryFn: device_id
        ? ({ pageParam }) =>
            getMaintenanceItemsWithNotesByDeviceId({ device_id, page: pageParam, size: NOTES_PAGE_SIZE })
        : skipToken,

      initialPageParam: 1, // ! 0 won't work
      getNextPageParam: (lastPage, allPages, lastPageParam) => {
        const totalCountReceived = allPages.flatMap((page) => page.data).length;
        const totalCountAvailable = lastPage.count ?? 0;
        if (totalCountReceived >= totalCountAvailable) return undefined;
        return lastPageParam + 1;
      },

      meta: {
        errorMessage: entitiesErrorMessage,
      },
      select: ({ pages }) => pages.flatMap((page) => page.data),
    }),
};
